import actions from '../constants';

export const closeWelcome = function() {
  return {
    type: actions.CLOSE_WELCOME
  };
}

export const changeSection = function(section) {
  return {
    type: actions.CHANGE_SECTION,
    section: section
  };
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/actions/welcome.js